import styled, { css, CSSProp } from 'styled-components'

export const PlaceholderImage = styled.div`
  ${({ theme }): CSSProp => css`
    background-color: ${theme.colours.primaryTint1};
    width: 100%;
    padding-bottom: 75%;
    margin-bottom: 2rem;

    @media only screen and ${theme.breakpoints.toNormalScreen} {
      margin-bottom: 1.5rem;
    }
  `}
`
